import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { AssetsService } from '../../../services/assetsService';

export const SelectAsset = ({ selectedAsset, onChange, idAssetType, getAllAssets, disabledField }) => {
  const { translate: t } = useDictionaryTranslation();
  const [assets, setAsset] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectAsset = (item) => {
    let selectedOption;
    if (item) selectedOption = assets.find((s) => s._id === item.value);
    return onChange?.(selectedOption);
  };

  const getAssets = useCallback(
    async (search) => {
      setLoading(true);
      try {
        const result = await getAllAssets({
          search,
          assetTypeId: idAssetType,
        });
        setAsset(result.assets);
      } catch (error) {
        setAsset([]);
      } finally {
        setLoading(false);
      }
    },
    [idAssetType, getAllAssets],
  );

  const getOptionData = useCallback((asset) => {
    return {
      value: asset._id,
      label: `${asset.reference} - ${asset.name}`,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('assetPlaceholder')}
      isLoading={loading}
      onChange={selectAsset}
      options={assets}
      value={selectedAsset}
      onSearch={getAssets}
      getOptionData={getOptionData}
      disabled={disabledField}
    />
  );
};

SelectAsset.defaultProps = {
  getAllAssets: AssetsService.getAssetsByType,
};

SelectAsset.propTypes = {
  selectedAsset: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    reference: PropTypes.string,
  }),
  idAssetType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  getAllAssets: PropTypes.func,
  disabledField: PropTypes.bool,
};
